import React from 'react';
import Layout from '../../components/Layout';
import { PageProps } from '../../App';
import { Link } from 'react-router-dom';

// Componente da página de Data Lakehouse com tipagem correta
const DataLakehousePage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-lupa-orange to-lupa-yellow overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
                Data Lakehouse
              </h1>
              <p className="mt-6 text-xl text-white/90 max-w-3xl mx-auto">
                A evolução da arquitetura de dados que combina o melhor dos Data Lakes e Data Warehouses para impulsionar seu negócio.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>

        {/* Conteúdo Principal */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-6">O que é um Data Lakehouse?</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Um Data Lakehouse é uma arquitetura moderna de dados que combina o melhor de dois mundos: a flexibilidade e escalabilidade dos Data Lakes com a confiabilidade, governança e desempenho dos Data Warehouses tradicionais.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Esta abordagem inovadora permite que as empresas armazenem todos os seus dados (estruturados, semiestruturados e não estruturados) em um único repositório, eliminando silos de informação e possibilitando análises avançadas, machine learning e business intelligence na mesma plataforma.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Com um Data Lakehouse, sua empresa pode finalmente unificar suas estratégias de dados, reduzir custos operacionais e acelerar a extração de insights valiosos para o negócio, tudo isso mantendo a qualidade e confiabilidade que você precisa para tomar decisões importantes.
              </p>
              <div className="mt-8">
                <Link to="/solucoes/lupa-paranoa" className="btn-primary">
                  Conheça o Lupa Paranoá
                </Link>
              </div>
            </div>
            <div className="bg-gray-100 dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Principais Benefícios</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Armazenamento unificado:</span> Mantenha todos os seus dados em um único local, eliminando silos e redundâncias.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Transações ACID:</span> Garanta consistência e confiabilidade dos dados, mesmo em operações complexas.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Esquema flexível:</span> Adapte-se rapidamente às mudanças de requisitos sem comprometer a governança.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Suporte a múltiplas cargas de trabalho:</span> Execute BI, SQL, análises e machine learning na mesma plataforma.</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Redução de custos:</span> Diminua significativamente os custos operacionais e de infraestrutura.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Comparação entre Data Lake, Data Warehouse e Data Lakehouse */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Comparação: Data Lake vs. Data Warehouse vs. Data Lakehouse</h2>
            <div className="overflow-hidden bg-white dark:bg-gray-800 rounded-xl shadow-lg">
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className="bg-lupa-purple text-white">
                      <th className="py-3 px-4 text-left">Características</th>
                      <th className="py-3 px-4 text-left">Data Lake</th>
                      <th className="py-3 px-4 text-left">Data Warehouse</th>
                      <th className="py-3 px-4 text-left bg-lupa-orange">Data Lakehouse</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Tipos de dados</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Estruturados, semiestruturados e não estruturados</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Principalmente estruturados</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Estruturados, semiestruturados e não estruturados</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Esquema</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Schema-on-read (flexível)</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Schema-on-write (rígido)</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Schema enforcement flexível</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Custo de armazenamento</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Baixo</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Alto</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Baixo</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Desempenho de consultas</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Variável, geralmente mais lento</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Rápido e otimizado</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Rápido e otimizado</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Transações ACID</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Não</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Sim</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Sim</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Governança de dados</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Limitada</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Forte</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Forte</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Suporte a Machine Learning</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Bom</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Limitado</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Excelente</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 font-medium text-gray-700 dark:text-gray-300">Escalabilidade</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Alta</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300">Limitada</td>
                      <td className="py-3 px-4 text-gray-700 dark:text-gray-300 bg-lupa-orange/10">Alta</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mt-8 bg-gray-100 dark:bg-gray-800 p-6 rounded-lg">
              <p className="text-gray-700 dark:text-gray-300 italic">
                "O Data Lakehouse representa a evolução natural das arquiteturas de dados, combinando o melhor dos dois mundos para atender às necessidades modernas de análise e inteligência de negócios."
              </p>
            </div>
          </div>

          {/* Arquitetura Data Lakehouse */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Arquitetura Data Lakehouse</h2>
            <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center p-6 bg-gray-50 dark:bg-gray-700 rounded-lg">
                  <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                    <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Camada de Armazenamento</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Armazena dados brutos em formatos abertos e de baixo custo, como Parquet, ORC ou Avro, mantendo a flexibilidade dos Data Lakes.
                  </p>
                  <ul className="mt-4 text-left space-y-2">
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Armazenamento de baixo custo
                    </li>
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Formatos abertos e padronizados
                    </li>
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Suporte a todos os tipos de dados
                    </li>
                  </ul>
                </div>
                <div className="text-center p-6 bg-gray-50 dark:bg-gray-700 rounded-lg">
                  <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                    <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Camada de Metadados</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Gerencia esquemas, garante consistência ACID e otimiza consultas para melhor desempenho, trazendo a confiabilidade dos Data Warehouses.
                  </p>
                  <ul className="mt-4 text-left space-y-2">
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Controle de versão de dados
                    </li>
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Garantia de transações ACID
                    </li>
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Indexação e otimização de consultas
                    </li>
                  </ul>
                </div>
                <div className="text-center p-6 bg-gray-50 dark:bg-gray-700 rounded-lg">
                  <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                    <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Camada de API</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Fornece interfaces para SQL, análises, BI e ferramentas de machine learning, permitindo múltiplos casos de uso na mesma plataforma.
                  </p>
                  <ul className="mt-4 text-left space-y-2">
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Suporte a SQL e BI tradicional
                    </li>
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      APIs para Machine Learning
                    </li>
                    <li className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                      <svg className="h-4 w-4 text-lupa-orange mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4" />
                      </svg>
                      Integração com ferramentas de análise
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Casos de Uso */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Casos de Uso do Data Lakehouse</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Business Intelligence</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Análises e relatórios de negócios com desempenho superior e dados mais completos e atualizados.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Machine Learning</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Desenvolvimento e implantação de modelos de ML com acesso direto a todos os dados da empresa.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Análise em Tempo Real</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Processamento e análise de dados em tempo real para decisões imediatas e ações oportunas.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Governança de Dados</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Implementação de políticas de segurança, privacidade e conformidade em todos os dados da organização.
                </p>
              </div>
            </div>
          </div>

          {/* Por que escolher o Lupa Paranoá */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Por que escolher o Lupa Paranoá para seu Data Lakehouse</h2>
            <div className="bg-gradient-to-r from-lupa-purple/10 to-lupa-orange/10 dark:from-lupa-purple/20 dark:to-lupa-orange/20 p-8 rounded-xl shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">A Solução Completa para sua Jornada de Dados</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    O <Link to="/solucoes/lupa-paranoa" className="text-lupa-orange hover:underline">Lupa Paranoá</Link> é nossa solução de Data Lakehouse que vai além da teoria, oferecendo uma implementação prática e adaptada à realidade do seu negócio.
                  </p>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Com o Paranoá, você não apenas obtém uma arquitetura moderna de dados, mas também um parceiro que entende seus desafios e trabalha lado a lado com sua equipe para garantir o sucesso da implementação.
                  </p>
                  <h4 className="text-xl font-bold text-lupa-purple dark:text-white mt-6 mb-3">Diferenciais do Lupa Paranoá:</h4>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Implementação personalizada:</span> Adaptamos a solução às suas necessidades específicas, não o contrário.</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Tecnologia aberta:</span> Baseado em soluções open source e com parceria Cloudera, garantindo flexibilidade e sem aprisionamento tecnológico.</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                      <span className="text-gray-700 dark:text-gray-300"><span className="font-semibold">Integração com outras soluções:</span> Conecte-se facilmente com nossas soluções de IA e análise preditiva para maximizar o valor dos seus dados.</span>
                    </li>
                  </ul>
                  <div className="mt-8">
                    <Link to="/solucoes/lupa-paranoa" className="btn-primary">
                      Conheça o Lupa Paranoá
                    </Link>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-4">Benefícios para o seu Negócio</h3>
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <div className="flex-shrink-0 w-10 h-10 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-bold text-lupa-purple dark:text-white">Redução no tempo de implementação</h4>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                          Nossa metodologia ágil e experiência permitem uma implementação mais rápida e eficiente.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="flex-shrink-0 w-10 h-10 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-bold text-lupa-purple dark:text-white">Economia em custos operacionais</h4>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                          Unificando suas plataformas de dados, você reduz significativamente os custos de infraestrutura e manutenção.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="flex-shrink-0 w-10 h-10 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-bold text-lupa-purple dark:text-white">Aumento na produtividade analítica</h4>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                          Seus analistas e cientistas de dados trabalham com dados mais completos e ferramentas mais eficientes.
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="flex-shrink-0 w-10 h-10 bg-lupa-orange rounded-full flex items-center justify-center mr-4">
                        <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-bold text-lupa-purple dark:text-white">Governança e segurança aprimoradas</h4>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                          Políticas de segurança e governança unificadas para todos os seus dados, garantindo conformidade e proteção.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tecnologias Relacionadas */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Tecnologias Relacionadas</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <Link to="/tecnologias/big-data" className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300 mb-2">Big Data</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Entenda como o Data Lakehouse se relaciona com as tecnologias de Big Data e como elas se complementam.
                </p>
                <div className="text-lupa-orange font-medium flex items-center">
                  Saiba mais
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
              <Link to="/tecnologias/ia" className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300 mb-2">Inteligência Artificial</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Descubra como o Data Lakehouse potencializa aplicações de IA ao fornecer dados de alta qualidade e em grande escala.
                </p>
                <div className="text-lupa-orange font-medium flex items-center">
                  Saiba mais
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
              <Link to="/solucoes/lupa-paranoa" className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-lupa-orange group">
                <div className="w-16 h-16 bg-lupa-purple rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white group-hover:text-lupa-orange transition-colors duration-300 mb-2">Lupa Paranoá</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Conheça nossa solução completa de Data Lakehouse, projetada para transformar seus dados em valor real para o negócio.
                </p>
                <div className="text-lupa-orange font-medium flex items-center">
                  Saiba mais
                  <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
            </div>
          </div>

          {/* FAQ */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Perguntas Frequentes</h2>
            <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Qual a diferença entre Data Lake, Data Warehouse e Data Lakehouse?</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Um Data Lake armazena dados brutos em seu formato original, mas carece de governança e desempenho para consultas. Um Data Warehouse oferece dados estruturados e otimizados para consultas, mas é menos flexível e mais caro. O Data Lakehouse combina o melhor dos dois: armazenamento econômico e flexível com governança e desempenho para consultas.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Preciso substituir minha infraestrutura atual para implementar um Data Lakehouse?</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Não necessariamente. O Data Lakehouse pode ser implementado gradualmente, integrando-se à sua infraestrutura existente. Nossa solução Lupa Paranoá é projetada para trabalhar com seus sistemas atuais, permitindo uma migração suave e sem interrupções.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Quanto tempo leva para implementar um Data Lakehouse?</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    O tempo de implementação varia conforme a complexidade do seu ambiente de dados, mas com o Lupa Paranoá, podemos entregar os primeiros resultados em 4 a 8 semanas. Trabalhamos com uma abordagem ágil, entregando valor incrementalmente.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">O Data Lakehouse é adequado para pequenas e médias empresas?</h3>
                  <p className="text-gray-700 dark:text-gray-300">
                    Sim. O Data Lakehouse é escalável e pode ser implementado de acordo com as necessidades e orçamento da sua empresa. O Lupa Paranoá oferece opções para empresas de todos os tamanhos, permitindo que você comece pequeno e cresça conforme necessário.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-20 bg-gradient-to-r from-lupa-purple to-lupa-purple-dark rounded-xl p-8 md:p-12 shadow-xl">
            <div className="md:flex md:items-center md:justify-between">
              <div className="md:w-2/3">
                <h2 className="text-3xl font-bold text-white mb-4">Pronto para modernizar sua infraestrutura de dados?</h2>
                <p className="text-white/90 text-lg mb-6 md:mb-0">
                  Descubra como o Lupa Paranoá pode ajudar sua empresa a implementar uma arquitetura Data Lakehouse moderna e eficiente.
                </p>
              </div>
              <div className="md:w-1/3 text-center">
                <Link to="/solucoes/lupa-paranoa" className="inline-block bg-white text-lupa-purple font-bold py-3 px-8 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                  Conheça o Lupa Paranoá
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DataLakehousePage;
